const lightbox = "futl1fihu0n";

export { lightbox };
import "./transcript-button.styles.linaria.module.css";
//# sourceMappingURL=transcript-button.styles.js.map
